
import { Lens, PlusWhite } from '@icons';
import { getOEChecklistQuestions } from '@lib/api';
import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useRef, useState } from 'react';
import { Button, FormControl } from 'react-bootstrap';
import { FilterFieldType } from './CustomFilter';
import { Loading } from '@components/atomic/atoms';


type OeChecklistQuestionType = {
    code: string
    number: number,
    questions: string,
    procedure: null | string,
    objective: string,
    note: string,
    exportable: boolean,
    entityCode: string,
    entityType: string,
    sectionNumber: number,
    sectionName: string,
    questionsFormatted: null | string,
    codeExportable: null | string,
    isUsed: boolean
}

interface ControlOptionProps {
    field: FilterFieldType;
    activeFilters: { [key: string]: (string)[] };
    handleFilterSet: (field: FilterFieldType, option: { value: string }, isActive: boolean) => void;
}

const ControlOption: React.FC<ControlOptionProps> = ({ field, activeFilters, handleFilterSet }) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleIsOpen = () => setIsOpen(prevIsOpen => !prevIsOpen);

    const [searchTerm, setSearchTerm] = useState("");

    const contentRef = useRef<HTMLDivElement>(null);

    const { data: checklistQuestions, isPending: isPendingChecklistQuestions } = useQuery<{ data: OeChecklistQuestionType[] }>({
        queryKey: ["oechecklistquestions", field.entityType],
        queryFn: () => getOEChecklistQuestions(field.entityType || ""),
        enabled: !!field.entityType && isOpen
    })

    useEffect(() => {
        if (!isPendingChecklistQuestions) {
            contentRef.current.style.maxHeight = isOpen ? `${contentRef.current?.scrollHeight}px` : "0px";
        }
    }, [isPendingChecklistQuestions, isOpen])

    return <> <p>Filtra per domande presenti nella checklist</p>
        <Button
            onClick={toggleIsOpen}
            className='btn custom-primary-button'
            style={{
                textTransform: "none",
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                textDecoration: "none",
                width: "fit-content",
                fontWeight: 500,
                padding: "6px 16px"
            }}>
            scegli dalla lista di domande <PlusWhite />
        </Button>
        <div style={{
            width: "100%",
            marginBlock: isOpen ? '24px' : '0',
            maxHeight: isOpen ? contentRef.current?.scrollHeight : 0,
            overflow: "hidden",
            transition: "max-height 0.3s ease",
            display: "grid", gap: "8px"
        }}
            ref={contentRef}
        >
            {isPendingChecklistQuestions ? <Loading /> :
                <>
                    <div style={{
                        position: "relative",
                        marginBottom: "32px",
                        maxWidth: "300px"
                    }}>

                        <FormControl
                            type="text"
                            placeholder="Cerca una domanda..."
                            id='search-input'
                            value={searchTerm}
                            onChange={(event) => setSearchTerm(event.target.value)}
                        // style={{ maxWidth: "300px" }}
                        />
                        <Lens style={{
                            position: "absolute",
                            top: "50%",
                            right: "12px",
                            transform: "translateY(-50%)"
                        }} />
                    </div>

                    {checklistQuestions?.data.filter((question) => {
                        return question.questions.toLowerCase().includes(searchTerm.toLowerCase());
                    }).map((question) => {
                        const isActive = activeFilters[`${field.entityType}_question_code`]?.includes(question.code) || false;
                        return <div key={question.code} style={{
                            // textOverflow: 'ellipsis',
                            // overflow: 'hidden',
                            // whiteSpace: 'nowrap',
                            display: 'flex',
                            // alignItems: "center",
                            gap: "8px",

                            // height: "100%"
                        }}>
                            <input type="checkbox" id={`filter-${question.code}`}
                                checked={isActive}
                                onChange={() => {

                                    const newFilter = {
                                        ...field,
                                        name: `${field.entityType}_question_code`,
                                        queryParamName: `${field.entityType}_question_code`
                                    }

                                    handleFilterSet(newFilter, { value: question.code }, isActive);
                                    // handleFilterSet(field, option, isActive);
                                    // setActiveFilters(prev => {
                                    //     const newFilters = { ...prev };
                                    //     const current = newFilters[fieldName] ?? [];

                                    //     if (current.includes(option.value)) {
                                    //         // rimuovi
                                    //         const updated = current.filter(value => value !== option.value);
                                    //         if (updated.length > 0) {
                                    //             newFilters[fieldName] = updated;
                                    //         } else {
                                    //             delete newFilters[fieldName];
                                    //         }
                                    //     } else {
                                    //         // aggiungi
                                    //         newFilters[fieldName] = [...current, option.value];
                                    //     }

                                    //     return newFilters;
                                    // });
                                }}

                            />
                            <label htmlFor={`filter-${question.code}`} style={{
                                // textOverflow: 'ellipsis',
                                // overflow: 'hidden',
                                // whiteSpace: 'nowrap',
                            }}>{question.code} - {question.questions}</label>
                        </div>
                    })}
                </>
            }


        </div>
    </>
}

export default ControlOption